import { z } from "zod";
import { Timestamps } from "../../common/index.ts";
import { EntityTypeId } from "../fsm.schema.ts";

/**
 * @description An EntityType represents a kind of entity. This can be a User, a Profile, a Role or a System.
 */
export const EntityTypeDto = z
  .object({
    id: EntityTypeId,
    name: z.string().min(1),
    description: z.string().nullable(),
  })
  .merge(Timestamps);

export type EntityTypeDto = z.infer<typeof EntityTypeDto>;

export const CreateEntityTypeInput = z.object({
  name: z.string().min(1),
  description: z.string().nullable().optional(),
});
export type CreateEntityTypeInput = z.infer<typeof CreateEntityTypeInput>;

export const UpdateEntityTypeInput = z.object({
  name: z.string().min(1).optional(),
  description: z.string().nullable().optional(),
});
export type UpdateEntityTypeInput = z.infer<typeof UpdateEntityTypeInput>;
